import React, { useRef } from 'react'
import { ScrollScene, UseCanvas, useScrollRig, styles } from '@14islands/r3f-scroll-rig'
import { MeshDistortMaterial } from '@react-three/drei'
import { WebGLText } from '@14islands/r3f-scroll-rig/powerups'

export const Headline = ({ children, ...props }) => (
  <Text font="fonts/OTF/ClashDisplay-Bold.otf" {...props}>
    {children}
  </Text>
)

export const Subtitle = ({ children, ...props }) => (
  <Text font="fonts/PlayfairDisplay-Italic.woff" {...props}>
    {children}
  </Text>
)

export const BodyCopy = Text

export function Text({ children, wobble, className, font = 'fonts/OTF/ClashDisplay-Regular.otf', as: Tag = 'span', ...props }) {
  const el = useRef()
  const { hasSmoothScrollbar } = useScrollRig()
  return (
    <>
    
      <Tag ref={el} className={styles.transparentColorWhenSmooth + ' ' + className} style={{ display: 'block' }} {...props}>
        {children}
      </Tag>

      {hasSmoothScrollbar && (
        <UseCanvas debug={false}>
          <ScrollScene track={el}>
            {(props) => (
              <WebGLText
                el={el} // getComputedStyle is called on this element
                font={font}
                glyphGeometryDetail={16}
                {...props} 
              >
                {wobble && <MeshDistortMaterial speed={2} distort={0.15} />}
                {children}
              </WebGLText>
            )}
          </ScrollScene>
        </UseCanvas>
      )}
    </>
  )
}
